import { render, staticRenderFns } from "./medkon_tren_media_konvensional.vue?vue&type=template&id=26d5a4ee"
import script from "./medkon_tren_media_konvensional.vue?vue&type=script&lang=js"
export * from "./medkon_tren_media_konvensional.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports